'use client';

import { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';
import { memo } from 'react';
import { DesktopWalkthroughStep } from '../devices/DesktopWalkthroughStep';
import { MobileWalkthroughStep } from '../devices/MobileWalkthroughStep';
import { TabletWalkthroughStep } from '../devices/TabletWalkthroughStep';

/**
 * Type-safe registry mapping device variants to step components.
 * Each device component handles its own display type routing internally.
 */
export const WalkthroughStepRendererMap = {
  [DeviceVariantType.DESKTOP]: memo(DesktopWalkthroughStep),
  [DeviceVariantType.MOBILE]: memo(MobileWalkthroughStep),
  [DeviceVariantType.TABLET]: memo(TabletWalkthroughStep),
} as const;

/**
 * WalkthroughStepRenderer - Factory that returns the appropriate step component for a device.
 */
export function WalkthroughStepRenderer({ device, handleMissingTargetElement }: { device: DeviceVariantType, handleMissingTargetElement?: () => void }) {
  const StepComponent = WalkthroughStepRendererMap[device];
  return <StepComponent handleMissingTargetElement={handleMissingTargetElement} />;
}
